var _text;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 66,
    viewBox: "0 0 51 66"
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    "data-name": "\\uD83C\\uDF7E",
    transform: "translate(0 50)",
    fill: "#202124",
    fontSize: 50,
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    letterSpacing: "0em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD83C\uDF7E"))));
}

export default SvgParty;